import { get, post } from '@/utils/http.js'

//更多报警详情
export const getHjMsg = (data) => post('/monitor/findonlytwenty', data);

//处理
export const handleById = (params) => post(`/monitor/dealone`, params);

//一键处理
export const handleByCom = (id) => post(`/monitor/dealday?c_number=${id}`, { c_number: id });

//更多报警列表
export const getHjList = (data) => get('/monitor/selectPage', data);

//更多报警列表
export const getMoreHjList = (data) => post('/monitor/findonlytwenty', data);


//数量
export const getHjNum = (data) => post('/monitor/historyfirenum', data);

//unit
export const getUnit = (c_number) => post('/monitor/detailbycompany', { c_number: c_number })

//单位数量
export const getUnitNum = (data) => post('demarcate/leftfind', data)

//  名称修改
export const editName = (data) => get('/system/dict/data/selectIconTitle', data)

// 获取图片验证码
export const changeImg = (data) => get('/captchaImage',data)
